module.exports = __webpack_public_path__ + "static/media/logo-apps-white.82eea79e.png";